import { useState } from "react";
import { AppSidebar } from "@/components/layout/AppSidebar"
import { MobileSidebar } from "@/components/layout/MobileSidebar"

// Shadcn components
import { SidebarProvider } from "@/components/ui/sidebar"

// Icons
import { Menu } from "lucide-react";

export default function Layout({ children }: { children: React.ReactNode }) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  return (
    <SidebarProvider defaultOpen>
      <div className="relative min-h-screen w-full">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block">
          <AppSidebar />
        </div>

        {/* Mobile Navigation */}
        <div className="lg:hidden">
          <button
            onClick={() => setIsMobileNavOpen(true)}
            className="fixed top-4 left-4 z-40 p-2 bg-background rounded-lg shadow-md hover:bg-accent"
            aria-label="Open menu"
          >
            <Menu className="h-6 w-6" />
          </button>
          <MobileSidebar
            isOpen={isMobileNavOpen}
            onClose={() => setIsMobileNavOpen(false)}
          />
        </div>

        {/* Main Content */}
        <div className="lg:pl-64 min-h-screen">
          <main className="w-full h-full">
            <div className="pt-20 lg:pt-24 max-w-7xl mx-auto px-8 lg:px-16">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  )
}